//Imports
import { USER_WATCH_LATER } from "../../../AppConstants/CollectionConstants";

// Firebase
import firebase, { firestore } from "../../../firebase/firebase";

const createWatchLater = async ({ targetId, userId, videoData = {} }) => {
  try {
    if (!userId && !targetId) {
      throw new Error("Please provide a userId and targetId");
    }

    const watchLaterId = `${userId}_${targetId}`;
    const docRef = firestore.collection(USER_WATCH_LATER).doc(watchLaterId);

    await firestore.runTransaction(async (transaction) => {
      let doc = await transaction.get(docRef);
      if (!doc.exists) {
        transaction.set(docRef, {
          id: watchLaterId,
          targetId,
          userId,
          creationTimestamp: firebase.firestore.Timestamp.now(),
          updatedTimestamp: firebase.firestore.Timestamp.now(),
          videoData: videoData,
        });
      }
    });

    return watchLaterId;
  } catch (error) {
    console.error("Error:: WATCH LATER:: ", error);
    throw error;
  }
};

const post = {
  createWatchLater,
};

export default post;
